export default {
  gscBaseChartTypes: {
    IMPRESSIONS: 'impressions',
    CLICKS: 'clicks',
    CTR: 'ctr'
  },
  gscBaseChartTypesData: {
    impressions: { name: 'SERP Impressions' },
    clicks: { name: 'Clicks' },
    ctr: { name: 'CTR' }
  },
  schedulerDateRangeType: {
    ONCE: -1,
    DAILY: 0,
    WEEKLY: 10,
    WEEKLY2: 20,
    WEEKLY3: 30,
    WEEKLY4: 40,
    MONTHLY: 50,
    MONTHLY2: 60,
    MONTHLY3: 70,
    MONTHLY6: 80
  },
  schedulerDateRangeTypes: {
    '-1': { value: -1, text: 'Only once' },
    0: { value: 0, text: 'Daily' },
    10: { value: 10, text: 'Weekly' },
    20: { value: 20, text: 'Every two weeks' },
    30: { value: 30, text: 'Every three weeks' },
    40: { value: 40, text: 'Every four weeks' },
    50: { value: 50, text: 'Monthly' },
    60: { value: 60, text: 'Every two month' },
    70: { value: 70, text: 'Every three month' },
    80: { value: 80, text: 'Every six month' }
  },
  schedulerStatus: {
    PENDING: 0,
    COMPLETED: 1,
    IN_PROGRESS: 2,
    ERROR: 3,
    WANING: 4
  },
  schedulerStatuses: {
    0: { value: 0, text: 'Pending', color: 'yellow' },
    1: { value: 1, text: 'Completed', color: 'green' },
    2: { value: 2, text: 'InProgress', color: 'blue' },
    3: { value: 3, text: 'Error', color: 'red' },
    4: { value: 4, text: 'Warning', color: 'orange' }
  },
  schedulerType: {
    ONCE: 0,
    PERIODIC: 1
  },
  schedulerTypes: {
    0: { value: 0, text: 'Once', color: 'grey' },
    1: { value: 1, text: 'Periodic', color: 'yellow' }
  },
  template_file_path: '/static/global_images/',
  gscViewId: 201693174,
  templateLevels: {
    BEGINNER: 1,
    PRO: 2,
    MASTER: 3,
    GLOBAL: 4
  }
}



// WEBPACK FOOTER //
// ./src/store/global/state.js